//Magasin pour stocker les infos de la vue de statut

import { ref } from "vue";
import { defineStore } from "pinia";
import { HttpStatusCode } from "@/lib/enums";

export const useStatusStore = defineStore("status", () => {
	const statusTitle = ref(""); //Le titre de la page de statut
	const statusMessage = ref(""); //message du statut
	const statusType = ref<HttpStatusCode>(); //type du statut
	/**
	 * Stocke les infos de la page de statut
	 * @param title
	 * @param message
	 * @param type
	 */
	function SetStatus(title: string, message: string, type: HttpStatusCode) {
		statusTitle.value = title;
		statusMessage.value = message;
		statusType.value = type;
	}

	return {
		statusTitle,
		statusMessage,
		statusType,
		SetStatus,
	};
});
